import ServicesPowerOptimizer from "../../components/ServicesPowerOptimizer/ServicesPowerOptimizer";


function ServicesPowerOptimizerPage() {
  return <ServicesPowerOptimizer />;
}

export default ServicesPowerOptimizerPage;
